import * as Types from '../../../../graphql-types'

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core'
import { OrderabilityFragmentFragmentDoc } from '../../../../fragments/__generated__/orderability.graphql-interface'
export type OutletFieldsWithoutArgsFragment = {
  __typename: 'Outlet'
  id: string
  name: string
  displayName: string
  description: string | null
  isOpen: boolean
  isOnline: boolean
  isOrderToTableEnabled: boolean
  closedUntil: string | null
  paymentMethods: Array<string>
  deliveryMinimumOrderValue: number | null
  collectionMinimumOrderValue: number | null
  ASAPDeliveryDuration: number | null
  prepTime: number
  distanceFromUserKM: number | null
  noPreordersBeforeOpening: boolean
  daysOfferedInAdvanceMax: number
  daysOfferedInAdvanceMin: number
  daysOfferedInAdvanceMinDelivery: number
  daysOfferedInAdvanceMaxDelivery: number
  daysOfferedInAdvanceMinCollection: number
  daysOfferedInAdvanceMaxCollection: number
  nextOpenDate: string
  outletLogoOverride: string | null
  allowPreorders: boolean
  asapAllowed: boolean
  coverImage: string | null
  featured: boolean
  availableFulfillmentMethods: Array<Types.FulfillmentMethodType>
  promoteOutlet: boolean
  availableFulfilmentInputMethods: Array<Types.NarrowFulfilmentMethodInputType>
  reviewSummary: {
    __typename: 'OutletReviewSummary'
    outletId: string
    reviewCount: number
    averageRating: number | null
    averageDelivery: number | null
    averageQuality: number | null
    averageService: number | null
  } | null
  outletCuisines: Array<{
    __typename: 'Cuisine'
    id: string
    name: string
    emoji: string | null
    imageSrc: string | null
    key: string | null
    outletCount: number | null
  }>
  specialOfferFlags: {
    __typename: 'SpecialOfferFlags'
    deliveryDeal: string | null
    collectionDeal: string | null
    tableDeal: string | null
  }
  openingTimesArray: Array<{
    __typename: 'OpeningTime'
    id: string
    timeSlot: number
    start: { __typename: 'DayAndTime'; id: string; day: number; time: string }
    end: { __typename: 'DayAndTime'; id: string; day: number; time: string }
  }>
  tables: Array<{ __typename: 'Table'; id: string; friendlyName: string }>
  restaurant: {
    __typename: 'Restaurant'
    id: string
    image: string | null
    name: string
  }
  outletLoyaltyCards: Array<{
    __typename: 'LoyaltyCard'
    id: string
    active: boolean
    termsAndConditions: string
    discountStrategy: Types.LoyaltyCardDiscountStrategy
    allowCashOrders: boolean
    isAvailableToday: boolean | null
    requiredStamps: number
    netTotal: number | null
    mainImage: string | null
    nameOverride: string | null
    loyaltyCardIcon: string
    loyaltyCardColor: string
    loyaltyCardStamps: Array<{
      __typename: 'LoyaltyCardStamp'
      id: string
      amountEarnedOnOrder: number
    }>
    discount: {
      __typename: 'Discount'
      id: string
      name: string
      discountAmount: number | null
      discountPercentage: number | null
      customerEmail: string | null
      daysOfWeek: Array<number> | null
      customerEnrolled: boolean
      endDate: string | null
      startDate: string | null
      minimumSubtotalGross: number | null
    }
  }>
}

export type OutletListAndSegmentsQueryVariables = Types.Exact<{
  input: Types.OutletsInput
  fulfilmentMethod: Types.NarrowFulfilmentMethodInputType
  acceptedFulfilmentMethods?: Types.InputMaybe<
    | Array<Types.NarrowFulfilmentMethodInputType>
    | Types.NarrowFulfilmentMethodInputType
  >
  fulfilmentLocation?: Types.InputMaybe<Types.FulfilmentLocationInput>
  fulfilmentTimeType?: Types.InputMaybe<Types.FulfilmentTimeType>
  businessSegmentTypes?: Types.InputMaybe<
    Array<Types.BusinessSegmentType> | Types.BusinessSegmentType
  >
  marketplaceId: Types.Scalars['String']
}>

export type OutletListAndSegmentsQuery = {
  outlets: Array<{
    __typename: 'Outlet'
    fulfilmentRange: string | null
    id: string
    name: string
    displayName: string
    description: string | null
    isOpen: boolean
    isOnline: boolean
    isOrderToTableEnabled: boolean
    closedUntil: string | null
    paymentMethods: Array<string>
    deliveryMinimumOrderValue: number | null
    collectionMinimumOrderValue: number | null
    ASAPDeliveryDuration: number | null
    prepTime: number
    distanceFromUserKM: number | null
    noPreordersBeforeOpening: boolean
    daysOfferedInAdvanceMax: number
    daysOfferedInAdvanceMin: number
    daysOfferedInAdvanceMinDelivery: number
    daysOfferedInAdvanceMaxDelivery: number
    daysOfferedInAdvanceMinCollection: number
    daysOfferedInAdvanceMaxCollection: number
    nextOpenDate: string
    outletLogoOverride: string | null
    allowPreorders: boolean
    asapAllowed: boolean
    coverImage: string | null
    featured: boolean
    availableFulfillmentMethods: Array<Types.FulfillmentMethodType>
    promoteOutlet: boolean
    availableFulfilmentInputMethods: Array<Types.NarrowFulfilmentMethodInputType>
    orderability: {
      __typename: 'OrderabilityOutput'
      prioritisedGenerallyAvailableFulfilmentMethods: Array<Types.NarrowFulfilmentMethodInputType>
      prioritisedCurrentlyAvailableFulfilmentMethods: Array<Types.NarrowFulfilmentMethodInputType>
      prioritisedGenerallyLocationAvailableFulfilmentMethods: Array<Types.NarrowFulfilmentMethodInputType>
      prioritisedCurrentlyLocationAvailableFulfilmentMethods: Array<Types.NarrowFulfilmentMethodInputType>
      delivery: {
        __typename: 'FulfilmentMethodOrderability'
        isGenerallyAvailable: boolean
        isAvailableToLocation: boolean
        asap: {
          __typename: 'FulfilmentMethodASAPOrderability'
          isGenerallyAvailable: boolean
          isAvailableNow: boolean
          availableFrom: string | null
          validUntil: string | null
        }
        preorder: {
          __typename: 'FulfilmentMethodPreorderOrderability'
          isGenerallyAvailable: boolean
          isAvailableForSelectedDate: boolean
          nextPreorderFulfilledAt: string | null
          isPreorderForLocalToday: boolean | null
        }
      }
      collection: {
        __typename: 'FulfilmentMethodOrderability'
        isGenerallyAvailable: boolean
        isAvailableToLocation: boolean
        asap: {
          __typename: 'FulfilmentMethodASAPOrderability'
          isGenerallyAvailable: boolean
          isAvailableNow: boolean
          availableFrom: string | null
          validUntil: string | null
        }
        preorder: {
          __typename: 'FulfilmentMethodPreorderOrderability'
          isGenerallyAvailable: boolean
          isAvailableForSelectedDate: boolean
          nextPreorderFulfilledAt: string | null
          isPreorderForLocalToday: boolean | null
        }
      }
      table: {
        __typename: 'FulfilmentMethodOrderability'
        isGenerallyAvailable: boolean
        isAvailableToLocation: boolean
        asap: {
          __typename: 'FulfilmentMethodASAPOrderability'
          isGenerallyAvailable: boolean
          isAvailableNow: boolean
          availableFrom: string | null
          validUntil: string | null
        }
        preorder: {
          __typename: 'FulfilmentMethodPreorderOrderability'
          isGenerallyAvailable: boolean
          isAvailableForSelectedDate: boolean
          nextPreorderFulfilledAt: string | null
          isPreorderForLocalToday: boolean | null
        }
      }
      anyFulfilmentMethod: {
        __typename: 'FulfilmentMethodOrderability'
        isGenerallyAvailable: boolean
        isAvailableToLocation: boolean
        asap: {
          __typename: 'FulfilmentMethodASAPOrderability'
          isGenerallyAvailable: boolean
          isAvailableNow: boolean
          availableFrom: string | null
          validUntil: string | null
        }
        preorder: {
          __typename: 'FulfilmentMethodPreorderOrderability'
          isGenerallyAvailable: boolean
          isAvailableForSelectedDate: boolean
          nextPreorderFulfilledAt: string | null
          isPreorderForLocalToday: boolean | null
        }
      }
    }
    outletAllDiscounts: Array<{
      __typename: 'Discount'
      id: string
      name: string
      customerEnrolled: boolean
      discountAmount: number | null
      discountPercentage: number | null
      minimumSubtotalGross: number | null
    }>
    statusText: {
      __typename: 'OutletStatusText'
      orderButtonTranslation: string
      openingTimeTranslation: {
        __typename: 'OpeningTimeTranslation'
        key: string
        datetime: string | null
        datetimeFormat: string | null
        days: string | null
      }
    }
    reviewSummary: {
      __typename: 'OutletReviewSummary'
      outletId: string
      reviewCount: number
      averageRating: number | null
      averageDelivery: number | null
      averageQuality: number | null
      averageService: number | null
    } | null
    outletCuisines: Array<{
      __typename: 'Cuisine'
      id: string
      name: string
      emoji: string | null
      imageSrc: string | null
      key: string | null
      outletCount: number | null
    }>
    specialOfferFlags: {
      __typename: 'SpecialOfferFlags'
      deliveryDeal: string | null
      collectionDeal: string | null
      tableDeal: string | null
    }
    openingTimesArray: Array<{
      __typename: 'OpeningTime'
      id: string
      timeSlot: number
      start: { __typename: 'DayAndTime'; id: string; day: number; time: string }
      end: { __typename: 'DayAndTime'; id: string; day: number; time: string }
    }>
    tables: Array<{ __typename: 'Table'; id: string; friendlyName: string }>
    restaurant: {
      __typename: 'Restaurant'
      id: string
      image: string | null
      name: string
    }
    outletLoyaltyCards: Array<{
      __typename: 'LoyaltyCard'
      id: string
      active: boolean
      termsAndConditions: string
      discountStrategy: Types.LoyaltyCardDiscountStrategy
      allowCashOrders: boolean
      isAvailableToday: boolean | null
      requiredStamps: number
      netTotal: number | null
      mainImage: string | null
      nameOverride: string | null
      loyaltyCardIcon: string
      loyaltyCardColor: string
      loyaltyCardStamps: Array<{
        __typename: 'LoyaltyCardStamp'
        id: string
        amountEarnedOnOrder: number
      }>
      discount: {
        __typename: 'Discount'
        id: string
        name: string
        discountAmount: number | null
        discountPercentage: number | null
        customerEmail: string | null
        daysOfWeek: Array<number> | null
        customerEnrolled: boolean
        endDate: string | null
        startDate: string | null
        minimumSubtotalGross: number | null
      }
    }>
  }>
  businessSegments: Array<{
    __typename: 'BusinessSegment'
    id: string
    name: string
    showName: boolean
    type: Types.BusinessSegmentType
    availabilityEndDate: string | null
    availabilityStartDate: string | null
    availabilityTimes: unknown | null
    description: string | null
    orderBy: Types.SegmentOrderBy | null
    outletLimit: number
    minOutletLimit: number
    position: number
    showDiscountLabels: boolean
    showFeaturedFlags: boolean
    linkToSegmentIndex: boolean
    hasOutlets: boolean
    cards: Array<
      | {
          __typename: 'Cuisine'
          id: string
          key: string | null
          name: string
          emoji: string | null
          imageSrc: string | null
          outletCount: number | null
        }
      | {
          __typename: 'LinkCard'
          id: string
          name: string
          url: string | null
          buttonText: string | null
          image: string | null
          description: string | null
          outlet: {
            __typename: 'Outlet'
            id: string
            name: string
            displayName: string
          } | null
          menuItem: { __typename: 'MenuItem'; id: string; name: string } | null
        }
      | {
          __typename: 'Outlet'
          fulfilmentRange: string | null
          id: string
          name: string
          displayName: string
          description: string | null
          isOpen: boolean
          isOnline: boolean
          isOrderToTableEnabled: boolean
          closedUntil: string | null
          paymentMethods: Array<string>
          deliveryMinimumOrderValue: number | null
          collectionMinimumOrderValue: number | null
          ASAPDeliveryDuration: number | null
          prepTime: number
          distanceFromUserKM: number | null
          noPreordersBeforeOpening: boolean
          daysOfferedInAdvanceMax: number
          daysOfferedInAdvanceMin: number
          daysOfferedInAdvanceMinDelivery: number
          daysOfferedInAdvanceMaxDelivery: number
          daysOfferedInAdvanceMinCollection: number
          daysOfferedInAdvanceMaxCollection: number
          nextOpenDate: string
          outletLogoOverride: string | null
          allowPreorders: boolean
          asapAllowed: boolean
          coverImage: string | null
          featured: boolean
          availableFulfillmentMethods: Array<Types.FulfillmentMethodType>
          promoteOutlet: boolean
          availableFulfilmentInputMethods: Array<Types.NarrowFulfilmentMethodInputType>
          orderability: {
            __typename: 'OrderabilityOutput'
            prioritisedGenerallyAvailableFulfilmentMethods: Array<Types.NarrowFulfilmentMethodInputType>
            prioritisedCurrentlyAvailableFulfilmentMethods: Array<Types.NarrowFulfilmentMethodInputType>
            prioritisedGenerallyLocationAvailableFulfilmentMethods: Array<Types.NarrowFulfilmentMethodInputType>
            prioritisedCurrentlyLocationAvailableFulfilmentMethods: Array<Types.NarrowFulfilmentMethodInputType>
            delivery: {
              __typename: 'FulfilmentMethodOrderability'
              isGenerallyAvailable: boolean
              isAvailableToLocation: boolean
              asap: {
                __typename: 'FulfilmentMethodASAPOrderability'
                isGenerallyAvailable: boolean
                isAvailableNow: boolean
                availableFrom: string | null
                validUntil: string | null
              }
              preorder: {
                __typename: 'FulfilmentMethodPreorderOrderability'
                isGenerallyAvailable: boolean
                isAvailableForSelectedDate: boolean
                nextPreorderFulfilledAt: string | null
                isPreorderForLocalToday: boolean | null
              }
            }
            collection: {
              __typename: 'FulfilmentMethodOrderability'
              isGenerallyAvailable: boolean
              isAvailableToLocation: boolean
              asap: {
                __typename: 'FulfilmentMethodASAPOrderability'
                isGenerallyAvailable: boolean
                isAvailableNow: boolean
                availableFrom: string | null
                validUntil: string | null
              }
              preorder: {
                __typename: 'FulfilmentMethodPreorderOrderability'
                isGenerallyAvailable: boolean
                isAvailableForSelectedDate: boolean
                nextPreorderFulfilledAt: string | null
                isPreorderForLocalToday: boolean | null
              }
            }
            table: {
              __typename: 'FulfilmentMethodOrderability'
              isGenerallyAvailable: boolean
              isAvailableToLocation: boolean
              asap: {
                __typename: 'FulfilmentMethodASAPOrderability'
                isGenerallyAvailable: boolean
                isAvailableNow: boolean
                availableFrom: string | null
                validUntil: string | null
              }
              preorder: {
                __typename: 'FulfilmentMethodPreorderOrderability'
                isGenerallyAvailable: boolean
                isAvailableForSelectedDate: boolean
                nextPreorderFulfilledAt: string | null
                isPreorderForLocalToday: boolean | null
              }
            }
            anyFulfilmentMethod: {
              __typename: 'FulfilmentMethodOrderability'
              isGenerallyAvailable: boolean
              isAvailableToLocation: boolean
              asap: {
                __typename: 'FulfilmentMethodASAPOrderability'
                isGenerallyAvailable: boolean
                isAvailableNow: boolean
                availableFrom: string | null
                validUntil: string | null
              }
              preorder: {
                __typename: 'FulfilmentMethodPreorderOrderability'
                isGenerallyAvailable: boolean
                isAvailableForSelectedDate: boolean
                nextPreorderFulfilledAt: string | null
                isPreorderForLocalToday: boolean | null
              }
            }
          }
          outletAllDiscounts: Array<{
            __typename: 'Discount'
            id: string
            name: string
            customerEnrolled: boolean
            discountAmount: number | null
            discountPercentage: number | null
            minimumSubtotalGross: number | null
          }>
          statusText: {
            __typename: 'OutletStatusText'
            orderButtonTranslation: string
            openingTimeTranslation: {
              __typename: 'OpeningTimeTranslation'
              key: string
              datetime: string | null
              datetimeFormat: string | null
              days: string | null
            }
          }
          reviewSummary: {
            __typename: 'OutletReviewSummary'
            outletId: string
            reviewCount: number
            averageRating: number | null
            averageDelivery: number | null
            averageQuality: number | null
            averageService: number | null
          } | null
          outletCuisines: Array<{
            __typename: 'Cuisine'
            id: string
            name: string
            emoji: string | null
            imageSrc: string | null
            key: string | null
            outletCount: number | null
          }>
          specialOfferFlags: {
            __typename: 'SpecialOfferFlags'
            deliveryDeal: string | null
            collectionDeal: string | null
            tableDeal: string | null
          }
          openingTimesArray: Array<{
            __typename: 'OpeningTime'
            id: string
            timeSlot: number
            start: {
              __typename: 'DayAndTime'
              id: string
              day: number
              time: string
            }
            end: {
              __typename: 'DayAndTime'
              id: string
              day: number
              time: string
            }
          }>
          tables: Array<{
            __typename: 'Table'
            id: string
            friendlyName: string
          }>
          restaurant: {
            __typename: 'Restaurant'
            id: string
            image: string | null
            name: string
          }
          outletLoyaltyCards: Array<{
            __typename: 'LoyaltyCard'
            id: string
            active: boolean
            termsAndConditions: string
            discountStrategy: Types.LoyaltyCardDiscountStrategy
            allowCashOrders: boolean
            isAvailableToday: boolean | null
            requiredStamps: number
            netTotal: number | null
            mainImage: string | null
            nameOverride: string | null
            loyaltyCardIcon: string
            loyaltyCardColor: string
            loyaltyCardStamps: Array<{
              __typename: 'LoyaltyCardStamp'
              id: string
              amountEarnedOnOrder: number
            }>
            discount: {
              __typename: 'Discount'
              id: string
              name: string
              discountAmount: number | null
              discountPercentage: number | null
              customerEmail: string | null
              daysOfWeek: Array<number> | null
              customerEnrolled: boolean
              endDate: string | null
              startDate: string | null
              minimumSubtotalGross: number | null
            }
          }>
        }
    >
  }>
}

export const OutletFieldsWithoutArgsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'OutletFieldsWithoutArgs' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Outlet' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isOpen' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isOnline' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'isOrderToTableEnabled' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'closedUntil' } },
          { kind: 'Field', name: { kind: 'Name', value: 'paymentMethods' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deliveryMinimumOrderValue' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'collectionMinimumOrderValue' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ASAPDeliveryDuration' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'prepTime' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'distanceFromUserKM' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'noPreordersBeforeOpening' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'daysOfferedInAdvanceMax' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'daysOfferedInAdvanceMin' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'daysOfferedInAdvanceMinDelivery' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'daysOfferedInAdvanceMaxDelivery' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'daysOfferedInAdvanceMinCollection' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'daysOfferedInAdvanceMaxCollection' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'nextOpenDate' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'outletLogoOverride' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'allowPreorders' } },
          { kind: 'Field', name: { kind: 'Name', value: 'asapAllowed' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reviewSummary' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'outletId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'reviewCount' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'averageRating' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'averageDelivery' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'averageQuality' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'averageService' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'outletCuisines' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'emoji' } },
                { kind: 'Field', name: { kind: 'Name', value: 'imageSrc' } },
                { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                { kind: 'Field', name: { kind: 'Name', value: 'outletCount' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'coverImage' } },
          { kind: 'Field', name: { kind: 'Name', value: 'featured' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'availableFulfillmentMethods' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'promoteOutlet' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'specialOfferFlags' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'deliveryDeal' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'collectionDeal' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'tableDeal' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'availableFulfilmentInputMethods' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'openingTimesArray' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'start' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'day' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'time' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'end' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'day' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'time' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'timeSlot' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'tables' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'friendlyName' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'restaurant' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'image' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'outletLoyaltyCards' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'active' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'termsAndConditions' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'discountStrategy' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'allowCashOrders' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'isAvailableToday' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'requiredStamps' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'netTotal' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'loyaltyCardStamps' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'amountEarnedOnOrder' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'discount' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'discountAmount' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'discountPercentage' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'customerEmail' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'daysOfWeek' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'customerEnrolled' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'customerEmail' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'endDate' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'startDate' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'minimumSubtotalGross' },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'mainImage' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nameOverride' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'loyaltyCardIcon' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'loyaltyCardColor' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<OutletFieldsWithoutArgsFragment, unknown>
export const OutletListAndSegmentsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'OutletListAndSegments' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'OutletsInput' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'fulfilmentMethod' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'NarrowFulfilmentMethodInputType' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'acceptedFulfilmentMethods' },
          },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NonNullType',
              type: {
                kind: 'NamedType',
                name: {
                  kind: 'Name',
                  value: 'NarrowFulfilmentMethodInputType',
                },
              },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'fulfilmentLocation' },
          },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'FulfilmentLocationInput' },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'fulfilmentTimeType' },
          },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'FulfilmentTimeType' },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'businessSegmentTypes' },
          },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NonNullType',
              type: {
                kind: 'NamedType',
                name: { kind: 'Name', value: 'BusinessSegmentType' },
              },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'marketplaceId' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'outlets' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'OutletFieldsWithoutArgs' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'orderability' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'fulfilmentLocation' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'fulfilmentLocation' },
                      },
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'OrderabilityFragment' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'outletAllDiscounts' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'fulfilmentMethod' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'fulfilmentMethod' },
                      },
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'customerEnrolled' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'discountAmount' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'discountPercentage' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'minimumSubtotalGross' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'fulfilmentRange' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: {
                        kind: 'Name',
                        value: 'acceptedFulfilmentMethods',
                      },
                      value: {
                        kind: 'Variable',
                        name: {
                          kind: 'Name',
                          value: 'acceptedFulfilmentMethods',
                        },
                      },
                    },
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'fulfilmentLocation' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'fulfilmentLocation' },
                      },
                    },
                  ],
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'statusText' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: {
                        kind: 'Name',
                        value: 'acceptedFulfilmentMethods',
                      },
                      value: {
                        kind: 'Variable',
                        name: {
                          kind: 'Name',
                          value: 'acceptedFulfilmentMethods',
                        },
                      },
                    },
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'fulfilmentLocation' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'fulfilmentLocation' },
                      },
                    },
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'fulfilmentTimeType' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'fulfilmentTimeType' },
                      },
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'openingTimeTranslation' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'key' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'datetime' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'datetimeFormat' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'days' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'orderButtonTranslation' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'businessSegments' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'marketplaceId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'marketplaceId' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'businessSegmentTypes' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'businessSegmentTypes' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'showName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'availabilityEndDate' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'availabilityStartDate' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'availabilityTimes' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'orderBy' } },
                { kind: 'Field', name: { kind: 'Name', value: 'outletLimit' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'minOutletLimit' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'position' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'showDiscountLabels' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'showFeaturedFlags' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'linkToSegmentIndex' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'hasOutlets' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'cards' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'outletsInput' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'input' },
                      },
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: { kind: 'Name', value: 'Outlet' },
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'FragmentSpread',
                              name: {
                                kind: 'Name',
                                value: 'OutletFieldsWithoutArgs',
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'orderability' },
                              arguments: [
                                {
                                  kind: 'Argument',
                                  name: {
                                    kind: 'Name',
                                    value: 'fulfilmentLocation',
                                  },
                                  value: {
                                    kind: 'Variable',
                                    name: {
                                      kind: 'Name',
                                      value: 'fulfilmentLocation',
                                    },
                                  },
                                },
                              ],
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'FragmentSpread',
                                    name: {
                                      kind: 'Name',
                                      value: 'OrderabilityFragment',
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'outletAllDiscounts',
                              },
                              arguments: [
                                {
                                  kind: 'Argument',
                                  name: {
                                    kind: 'Name',
                                    value: 'fulfilmentMethod',
                                  },
                                  value: {
                                    kind: 'Variable',
                                    name: {
                                      kind: 'Name',
                                      value: 'fulfilmentMethod',
                                    },
                                  },
                                },
                              ],
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'id' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'name' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'customerEnrolled',
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'discountAmount',
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'discountPercentage',
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'minimumSubtotalGross',
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'fulfilmentRange' },
                              arguments: [
                                {
                                  kind: 'Argument',
                                  name: {
                                    kind: 'Name',
                                    value: 'acceptedFulfilmentMethods',
                                  },
                                  value: {
                                    kind: 'Variable',
                                    name: {
                                      kind: 'Name',
                                      value: 'acceptedFulfilmentMethods',
                                    },
                                  },
                                },
                                {
                                  kind: 'Argument',
                                  name: {
                                    kind: 'Name',
                                    value: 'fulfilmentLocation',
                                  },
                                  value: {
                                    kind: 'Variable',
                                    name: {
                                      kind: 'Name',
                                      value: 'fulfilmentLocation',
                                    },
                                  },
                                },
                              ],
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'statusText' },
                              arguments: [
                                {
                                  kind: 'Argument',
                                  name: {
                                    kind: 'Name',
                                    value: 'acceptedFulfilmentMethods',
                                  },
                                  value: {
                                    kind: 'Variable',
                                    name: {
                                      kind: 'Name',
                                      value: 'acceptedFulfilmentMethods',
                                    },
                                  },
                                },
                                {
                                  kind: 'Argument',
                                  name: {
                                    kind: 'Name',
                                    value: 'fulfilmentLocation',
                                  },
                                  value: {
                                    kind: 'Variable',
                                    name: {
                                      kind: 'Name',
                                      value: 'fulfilmentLocation',
                                    },
                                  },
                                },
                                {
                                  kind: 'Argument',
                                  name: {
                                    kind: 'Name',
                                    value: 'fulfilmentTimeType',
                                  },
                                  value: {
                                    kind: 'Variable',
                                    name: {
                                      kind: 'Name',
                                      value: 'fulfilmentTimeType',
                                    },
                                  },
                                },
                              ],
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'openingTimeTranslation',
                                    },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'key' },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'datetime',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'datetimeFormat',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'days' },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'orderButtonTranslation',
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: { kind: 'Name', value: 'LinkCard' },
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'name' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'url' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'buttonText' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'outlet' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'id' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'name' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'displayName',
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'image' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'description' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'menuItem' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'id' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'name' },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: { kind: 'Name', value: 'Cuisine' },
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'key' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'name' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'emoji' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'imageSrc' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'outletCount' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    ...OutletFieldsWithoutArgsFragmentDoc.definitions,
    ...OrderabilityFragmentFragmentDoc.definitions,
  ],
} as unknown as DocumentNode<
  OutletListAndSegmentsQuery,
  OutletListAndSegmentsQueryVariables
>
